"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loop = exports.sGen = exports.copyToClipboard = exports.md5 = exports.getGravatarUrl = exports.getDocumentMeta = exports.trimmer = exports.sid = exports.uuid = exports.cnx = exports.sleep = void 0;
const MD5_1 = __importDefault(require("./MD5"));
exports.md5 = MD5_1.default;
const Clipboard_1 = __importDefault(require("./Clipboard"));
exports.copyToClipboard = Clipboard_1.default;
async function sleep(ms) {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
}
exports.sleep = sleep;
function cnx(...classes) {
    const del = [];
    classes.forEach((sel) => {
        if (typeof sel === 'string') {
            del.push(sel);
        }
        if (Array.isArray(sel)) {
            const [val, cl, cd] = sel;
            if (val) {
                del.push(cl);
            }
            else if (!val && !!cd) {
                del.push(cd);
            }
        }
    });
    return del.join(' ');
}
exports.cnx = cnx;
function sGen(inp) {
    return inp.replace(/[xy]/g, (c) => {
        // eslint-disable-next-line no-bitwise
        const r = (Math.random() * 16) | 0;
        // eslint-disable-next-line no-bitwise
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
exports.sGen = sGen;
function uuid() {
    return sGen('xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx');
}
exports.uuid = uuid;
function sid() {
    return sGen('xxxx-4xxx-yxxx');
}
exports.sid = sid;
function trimmer(inp) {
    if (inp.length > 20) {
        return `${inp.substring(0, 20)}...`;
    }
    return inp;
}
exports.trimmer = trimmer;
function getDocumentMeta(key) {
    const el = document
        .querySelector(`meta[name='${key}']`)
        ?.getAttribute('content');
    if (!el || el === '') {
        return null;
    }
    return el;
}
exports.getDocumentMeta = getDocumentMeta;
const getGravatarUrl = (email) => {
    const hash = (0, MD5_1.default)(email);
    return `https://www.gravatar.com/avatar/${hash}?d=identicon`;
};
exports.getGravatarUrl = getGravatarUrl;
function loop(n, fc) {
    return [...Array(n).keys()].map(fc);
}
exports.loop = loop;
